var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-biz-message-push-form-input"},[_c('el-input',_vm._b({attrs:{"show-word-limit":""},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'el-input',_vm.inputOpts,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }